module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"firm":"Firm","has_home":"H","has_life":"L"},"fr":{"firm":"Firme","has_home":"H","has_life":"V"}}')
  delete Component.options._Ctor
}
